import {CommonService} from '../../../shared/utils/common.service';
import {Observable} from 'rxjs';
import {UtilsService} from '../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root',
})
export class NotaMaquilaService {
  private diccionarioModulo: any;
  private url: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
  }


  obtenerPorId(idOrdenBalanza: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.notaMaquila.obtenerPorId +
      idOrdenBalanza
    );
  }

  imprimir(idOrdenBalanza: number): Observable<any> {
    return this._commom.peticionPostConHeader(
      this.url +
      this.diccionarioModulo.url.notaMaquila.imprimir +
      idOrdenBalanza,{}
    );
  }


}
